import { useGetAvailableSyncTasksQuery, useGetSyncMetricsQuery } from "state/rtkQuery/sync/syncQueries";

import { SYNC_ACTIONS } from "./syncActions";

// Housekeeping tasks (recovery.stale, beat.refresh_schedule, ...) run all the time and would bury the real syncs.
// Every real sync task is named sync.something, so anything else is a system task.
export const isSystemTask = (name) => !String(name || "").startsWith("sync.");

// The run history can only filter by task names to INCLUDE, so "hide system tasks" is done by asking for every
// non-system task name that exists. The names come from what has run in the last 30 days plus the registered tasks, so
// nothing needs hard-coding. `ready` is false only while the first lookup is loading.
export const useSyncTaskNames = () => {
  const { data, isLoading } = useGetSyncMetricsQuery({ lookback_hours: 720 });
  const { data: catalogue } = useGetAvailableSyncTasksQuery();
  const ran = (data?.by_task_name || []).map((row) => row.task_name);
  const everything = [...new Set([...ran, ...(catalogue?.available_tasks || []), ...SYNC_ACTIONS.map((action) => action.task)])].sort();
  const userNames = everything.filter((name) => !isSystemTask(name));
  const systemNames = ran.filter(isSystemTask).sort();
  return { userNames, systemNames, allNames: everything, ready: !isLoading, hasSystemRuns: systemNames.length > 0 };
};

// The task_name filter to send: an explicit choice always wins; otherwise system tasks are left out unless asked for.
export const taskNameFilter = ({ chosen = [], includeSystem, userNames }) => {
  if (chosen.length) return chosen.join(",");
  if (!includeSystem && userNames.length) return userNames.join(",");
  return "";
};
